<template>
	<div class="goods">
	  <v-head :title="title"></v-head>
	   <!--<div class="imgBox">
	   	 <img src="../../assets/images/Membership.jpg">
	   </div>-->
		<!-- 团体会员 -->
		<div v-if="isGroupMember" style="padding:0 10px;" >
			<div class="car-box group-box" id="card" v-cloak>
				<ul>
					<li :class="{'smallBottom':userInfo.company&&userInfo.company.length > 15}"
					>{{userInfo.name || '--'}}</li>
					<p class="fhNmageFont">{{getBranchName(userInfo.recommendUnitId)}}</p>
					<li></li>
					<li style="position: absolute; bottom: 9%;font-size: 6px; right: 23%;">{{userInfo.auditTime | formatDate}}</li>
				</ul>
			</div>
		</div>
		<!-- 个人会员 -->
		<div v-else>
			<div class="car-box isSSOC" id="card" v-cloak>
				<div id="qrcode" class="qrCode">
					<qrcode :value="codeUrl" :options="{ size: 62 }"></qrcode>
				</div>
				<template v-if="userInfo.portraitId">
					<div class="portrait" id="demo" :style="{backgroundImage:'url(' + PZUrl + ')'}"></div>
				</template>
				<ul>
					<li  :class="{'smallBottom':userInfo.company&&userInfo.company.length > 15}">{{userInfo.name || '--'}}</li>
					<li>{{userInfo.gender==1?"男":"女"}}</li>
					<li>{{getMemberType(userInfo.memberType) || '网员'}}</li>
					<li>{{userInfo.expiryDate | formatDate}}</li>
					<li>{{userInfo.memberNo || '未生成会员号'}}</li>
					 <li>{{getRecommendUnit(userInfo.recommendUnitId)}}</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
import {
	getUser,
	baseURL,
	getPortrait,
	getPZUrl,
	getAssociationCurrent,
	getDictionaryByCode,
	getDuesList,
	getBranchs,
	getPaymentList
} from "@/api/dictionary";
import Qrcode from "@xkeshi/vue-qrcode";
import vHead from "../../components/Subhead.vue";
import { Uploader,Toast,Button } from "vant";
import { mapGetters, mapState, mapMutations } from "vuex";
import {getSessionStore} from "@/utils/sessionStorage.js"

export default {
  data() {
    return {
	 codeUrl:'http://new.csfmember.org.cn/mobile/#/memberInfo?code=',
     title:"电子会员证",
     fileList: [],
	 photoList:[],
	 branchList:[],
	 page:1,
      orderAudit:{
        auditTime:'',
      },
	userInfo: {
		id: "",
		name: "未登录",
		memberTypes:''
	},
	cardName: "card.png",
	componentName: "",
	cardUrl: "",
	PZUrl: "", //头像地址
	singerList:[]
    };
  },
filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + ' 年 ' + MM + ' 月 ' + d + ' 日 ';
      }
    },
  components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
	[Button.name]: Button,
	Qrcode
  },
	computed: {
		...mapGetters(["commond", "isGroupMember","getMemberType"])
	},
	methods: {
		getAssociationCurrent() {
			getAssociationCurrent().then(res => {
				if (res.success) {
					this.componentName = res.result.name;
				}
			});
		},
		getDisplay(id) {
			getPZUrl({ id }).then(res => {
				if (res.success) {
					this.PZUrl = res.result;
				}
			});
		},
		getBranchName(code){
			let obj = this.branchList.filter(item => item.code == code);
			return obj && obj[0] && obj[0].name;
		},
		getSingerList(params){
			getDictionaryByCode(params)
				.then(res =>{
					this.singerList = res.result;
				})
		},
		getRecommendUnit(val) {
			let obj = this.branchList.find(item => item.code == val);

			if(obj) {
				return obj.name
			} else {
				return '~'
			}
		},
		getBranchs() {
			getBranchs()
				.then(res => {
					if(res.success) {
						this.branchList = res.result
					}

				})
		},
		compare(value){
			var obj = this.singerList.filter(function(item){
				return item.value == value;
			});
			if(!obj.length) return '网员';
			return obj[0].name;
		},
    getOder(){
	  const token = getSessionStore("access_token");
      this.loading = true;
      let orderTypeList = [1,3,4,5]
      getPaymentList({ orderTypeList: orderTypeList,"access_token":token }, this.page - 1)
        .then(res => {
          if(res.result.content && res.result.content[0] && res.result.content[0].orderAudit &&  res.result.content[0].orderAudit.auditTime){
            this.orderAudit = res.result.content[0].orderAudit;
            //取出时间  转化
          }
        })
        .catch(() => {
          this.$message.error("获取数据失败");
        })
        .finally(() => {
          this.loading = false;
        });


    },
		getUser() {
			return new Promise((resolve, reject) => {
				getUser()
						.then(data => {
							this.userInfo = data.result;
							this.codeUrl = this.codeUrl + this.userInfo.id;
							if(this.userInfo.memberCategory == 1){
								this.getSingerList('MEMBER_TYPE');
							}else{
								this.getSingerList('GROUP_TYPE');
							}
							resolve(data.result);
						})
						.catch(() => {
							this.$message.error("获取用户信息失败！");
						});
			});
		}
	},
	mounted: async function() {
		let data = await this.getUser();
		this.getAssociationCurrent();
		this.cardName = data.name + data.memberNo + ".png";
		this.getDisplay(data.portraitId);
		this.getOder();
		this.getBranchs();
	}
};
</script>

<style  lang="less" scoped>
.imgBox{
	padding:20px;
    img{ width: 100%; }
}
.nav-title {
	display: flex;
	color: #228ccd;
	font-weight: bold;
	align-items: center;
	img {
		width: 17px;
		margin-right: 12px;
	}
}
.car-box.isSSOC {
	position: relative;
	margin: 10px auto 0;
	height:540px;
	background: url("../../assets/images/huax_img.jpg") center no-repeat;
	background-size: 105%;
}
.car-box.isSSOC .memberBo{
	width: 110px;
	height: 12px;
	position: absolute;
    top: 195px;
    left:22px;
	font-size:12px;
}
.car-box.isSSOC ul {
	width: 190px;
    position: absolute;
    top:6.5rem;
    right: 0.5rem;
    text-align: center;
    line-height: 0;
}
.group-box {
	position: relative;
	height:540px;
	margin: 0 auto 0;
	background: url("../../assets/images/tfxqCard.jpg") center
	no-repeat;
	background-size: 100%;
}
.car-box.group-box ul {
	width: 80%;
	margin: 0 auto;
	// position:absolute;
    // top: 180px;
	// right: 0px;
	padding-top: 58%;
	text-align: left;
}
// .car-box.group-box div{ position: absolute; bottom: 94px; left: 44px;line-height: 17px;}
.car-box.group-box div li{font-size:12px;	min-height: 19px;	margin-bottom: 6px;}
.car-box ul li.smallBottom {
	margin-bottom: 5px !important;
	font-size:12px
}
.portrait {
    position: absolute;
    width: 1.49333rem;
    height: 2.10667rem;
    display: block;
    left: 160px;
    top: 135px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}
.isSSOC ul li {
	min-height: 17px;
    margin-bottom: 1.5px;
    font-size: 10px;
}
.group-box ul li {
	min-height: 18px;
	margin-bottom: 13px;
	font-size:18px;
	text-align:center;
}
.btn {
	display: block;
	width: 110px;
	height: 38px;
	margin: 38px auto 0;
	font-size: 14px;
	line-height: 38px;
	text-align: center;
	color: #fff;
	border-radius: 3px;
	background: #228ccd;
	cursor: pointer;
}
.btn:active {
	background: #1a6fa3;
}
.group-box .qrCode{  bottom: 37px;}

.qrCode{ position: absolute;     bottom: 25px;
width: 46px;
    height: 46px;
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
	right: 130px;}
.fhNmageFont{ text-align:center; font-size: 16px;    margin-top: 38%;}	

</style>